/**
 * Who read a message, and when.
 *
 * Fetched lazily — `enabled` is meant to be the hover card's open state. The message
 * item already carries `userReads` (readers, no timestamps), which is enough to render
 * the delivered/seen icon; only the "Seen by" panel needs `readAt`, and firing one
 * query per rendered bubble to get it is the N+1 the legacy office thread ships today.
 *
 * `userReads` cannot substitute for this endpoint even when a timestamp is wanted: it
 * carries plain user rows, so reading a date off one renders the reader's signup date.
 */

import {
  type ChannelReadReceipt,
  useGetChannelsMessagesReadsByCidByMessageId,
} from "./channel-endpoints";

export function useChannelReadReceipts(
  cid: string,
  messageId: string,
  enabled: boolean,
) {
  return useGetChannelsMessagesReadsByCidByMessageId({
    cid,
    messageId,
  }).get({ enabled: enabled && !!cid && messageId !== "" });
}

export type { ChannelReadReceipt };
